import { arrayUnion, doc, onSnapshot, setDoc } from "firebase/firestore";
import { db } from "../firebase/config";

const chatsCollection = () => {
  if (process.env.REACT_APP_FIREBASE_CHESS_CHATS_COLLECTION) {
    return process.env.REACT_APP_FIREBASE_CHESS_CHATS_COLLECTION;
  }
  const isProduction =
    process.env.REACT_APP_FIREBASE_ENV === "production" ||
    (process.env.REACT_APP_FIREBASE_ENV !== "development" &&
      process.env.NODE_ENV === "production");
  return isProduction ? "production_chessChats" : "chessChats";
};

const storageKey = (gameId) => `arcadeChessChat:${gameId}`;

const readLocal = (gameId) => {
  try {
    const raw = window.localStorage.getItem(storageKey(gameId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const writeLocal = (gameId, messages) => {
  try {
    window.localStorage.setItem(storageKey(gameId), JSON.stringify(messages.slice(-80)));
  } catch {
    // Ignore storage failures. Firestore is the shared copy.
  }
};

export const subscribeChessChat = (gameId, onMessages) => {
  if (!gameId) {
    onMessages([]);
    return () => {};
  }

  onMessages(readLocal(gameId));
  if (!db) return () => {};

  return onSnapshot(
    doc(db, chatsCollection(), gameId),
    (snap) => {
      const messages = snap.exists() ? snap.data().messages || [] : [];
      const sorted = [...messages].sort((a, b) => (a.createdAt || 0) - (b.createdAt || 0));
      writeLocal(gameId, sorted);
      onMessages(sorted);
    },
    () => onMessages(readLocal(gameId))
  );
};

export const sendChessMessage = async (gameId, message) => {
  const text = String(message?.text || "").trim().slice(0, 200);
  if (!gameId || !text) return;

  const payload = {
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    userId: String(message.userId || ""),
    displayName: String(message.displayName || "Player").trim().slice(0, 20) || "Player",
    text,
    createdAt: Date.now(),
  };

  const local = readLocal(gameId);
  writeLocal(gameId, [...local, payload]);

  if (!db) return;
  await setDoc(
    doc(db, chatsCollection(), gameId),
    { messages: arrayUnion(payload) },
    { merge: true }
  );
};
